import { render } from "./StorageSegments.vue?vue&type=template&id=64ca2938&scoped=true"
import script from "./StorageSegments.vue?vue&type=script&lang=js"
export * from "./StorageSegments.vue?vue&type=script&lang=js"

import "./StorageSegments.vue?vue&type=style&index=0&id=64ca2938&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ca2938"]])

export default __exports__